export const setMenuAreaClienteSelect = (context, payload) => {
  context.commit("setMenuAreaClienteSelect", payload);
};

export const setLoadingAction = (context, payload) => {
  context.commit("setLoadingAction", payload);
};
